<template>
  <div>
    Custom Fields
  </div>
</template>
<script>
  export default {
    name: 'custom-fields-settings'
  }
</script>
<style>
</style>
